import BossModel from "@/models/BossModel";
import User from '@/models/User/User';
import Country from '@/models/Country/Country';

export default class ExpertiseCountry extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'user/expertise-country';

    /**
     *
     * @type {string}
     */
    static entity = 'userExpertiseCountries';

    static fields() {
		return {
			id: this.attr(null),
			quote: this.attr(null),
			user_id: this.attr(null),
			country_id: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			long_quote: this.attr(null),
            user: this.belongsTo(User, 'user_id'),
            country: this.belongsTo(Country, 'country_id'),
		}
	}

    /**
     *
     * @param params
     * @returns {Promise<TResult>}
     */
    static get(params = {}) {
        return this.api()
            .filtered(params.filters)
            .paginator(params.paginator)
            .with(['country'])
            .ordered(params.sortBy)
            .get();
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    User() {
        return this.getRelated('user');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Country() {
        return this.getRelated('country');
    }
}
